import { tableFilterApi } from 'modules/tableFilter';
import { GET_FILTER_OPTIONS } from './getFilterOptions';
import { GET_FILTERS_OPTIONS } from './getFiltersOptions';
import { GET_VENDOR_OPPORTUNITIES_LIST } from './getVendorOpportunitiesList';
import { GET_VENDOR_OPPORTUNITIES_LIST_PARTNER } from './getVendorOpportunitiesListPartner';

import { CHECK_IS_BPFS_EXIST_FOR_ACCOUNT } from './getBusinessProcessFlowTemplates';
import { UPDATE_ROW_DISPLAY_STATUS } from './updateRowDisplayStatus';

export const opportunitiesListApi = {
  ...tableFilterApi,
  getFilterOptions: GET_FILTER_OPTIONS,
  getVendorOpportunitiesList: GET_VENDOR_OPPORTUNITIES_LIST,
  getVendorOpportunitiesListPartner: GET_VENDOR_OPPORTUNITIES_LIST_PARTNER,
  getFiltersOptions: GET_FILTERS_OPTIONS,

  getBusinessProcessFlowTemplates: CHECK_IS_BPFS_EXIST_FOR_ACCOUNT,
  updateRowDisplayStatus: UPDATE_ROW_DISPLAY_STATUS,
};

export * from './usePresets';
export * from './useFilterOptions';
